import { useEffect, useRef, useState } from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.css'
import { useFormik } from 'formik'
import { Input, } from '../../components/ModalInputs'
import * as Yup from 'yup'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import Button from '../../components/Button'
import Table from '../../components/Table'
import { IoIosAdd } from 'react-icons/io'
import EnrollModal from './EnrollModal/EnrollModal'
import { createMethodAssoc, createMethodAssocFile, deleteMethodAssocFile, deleteMethodAssocMid, updateMethodAssoc } from '../../actions/methodAssoc'
import CustomSelect from '../../components/CustomSelect'
import { arrayForSelect } from '../../utils/arrayForSelect'
import { getMethodAssocLevels } from '../../actions/methodAssocLevels'
import { api } from '../../App'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import { downloadFile } from '../../utils/fileDownload'


export default function ModalComponent({ data, closeModal, height, addMode, }) {

  const dispatch = useDispatch()
  const filePicker = useRef()

  const { list: levels } = useSelector(state => state.method_assoc_levels)
  const { methodAssoc, listMids } = useSelector(state => state.method_assoc)
  const [file, setFile] = useState(null);
  const [activeTab, setActiveTab] = useState(1); // 1 - Main, 2 - Equipment

  const [openEnrollModal, setOpenEnrollModal] = useState(false)
  const [selectedStudents, setSelectedStudents] = useState([])
  const [confirmation, setConfirmation] = useState(false);
  const [second, setSecond] = useState(false);
  const [fileSelected, setFileSelected] = useState(null)

  useEffect(() => {
    dispatch(getMethodAssocLevels())
  }, [file])

  useEffect(() => {
    methodAssoc && setValues(methodAssoc)
  }, [methodAssoc])

  useEffect(() => {
    (values?.file_list?.length > 0 && fileSelected) && fetchPhoto(fileSelected, values?.maid)
  }, [fileSelected])

  const handleCreate = () => {
    !second && dispatch(createMethodAssoc(values))
    second && closeModal() && setValues({})
    setSecond(true)
  }

  const handleUpdate = (values) => {
    dispatch(updateMethodAssoc(values))
    file && dispatch(createMethodAssocFile(file[0], values.maid))
    closeModal()
  }

  const handleChangeStudents = (student) => {
    if (typeof student === 'number') setSelectedStudents((prev) => prev.filter(el => el.mid !== student))
    else setSelectedStudents((prev) => !prev.find(el => el.mid === student.mid) ? [...prev, student] : prev.toSpliced(prev.indexOf(student), 1))
  }

  const {
    values,
    errors,
    touched,
    submitCount,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
  } = useFormik({
    initialValues: addMode ? {} : data,
    enableReinitialize: true,
    onSubmit: addMode ? handleCreate : handleUpdate
  })

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  useEffect(() => {
    setActiveTab(1)
  }, [data])


  const handleTab = (tab) => {
    setActiveTab(tab);
  }

  const openEnroll = () => {
    setOpenEnrollModal(true)
  }
  const closeEnroll = () => {
    setOpenEnrollModal(false)
  }

  const acceptConfirmation = (mid) => {
    handleChangeStudents(mid)
    dispatch(deleteMethodAssocMid(methodAssoc.maid, confirmation.id));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const handlePick = () => {
    filePicker.current.click()
  }
  const handleChangeFile = (e) => {
    setFile(Object.values(e.target.files))
    dispatch(createMethodAssocFile(e.target.files[0], values.maid))
  }
  const fetchPhoto = async (file_name, id) => {
    const { data } = await api.get(`/method_assoc/file/${id}/${file_name}`, { responseType: 'blob' });
    downloadFile(data, file_name, { openInNewTab: true })
  }
  const handleTakeFile = (file_name) => {
    setFileSelected(file_name)
  }

  const deleteClickHandler = (file) => (e) => {
    e.stopPropagation()
    dispatch(deleteMethodAssocFile(methodAssoc.maid, file.name));
  }
  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      height={height}
      classNames={{
        modal: styles.custom
      }}
      center
    >
      <>
        {confirmation && (
          <Confirmation
            top="30px"
            left="40px"
            title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
            acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
            rejectConfirmation={rejectConfirmation}
          />
        )}

        <div className={styles.modalMain}>
          <div className={styles.tabsHeader}>
            <div className={styles.title}>{values.maid
              ? 'Редактирование'
              : 'Добавление'}</div>
            <div className={styles.tabs}>
              <Button mode={activeTab === 1 ? '' : 'white'} onClick={() => handleTab(1)}>Главная</Button>
              {/* <Button mode={activeTab === 2 ? '' : 'white'} onClick={() => handleTab(2)}>Состав</Button> */}
              {values.maid &&
                <>
                  <Button mode={activeTab === 2 ? '' : 'white'} onClick={() => handleTab(2)}>Состав</Button>
                  <Button mode={activeTab === 3 ? '' : 'white'} onClick={() => handleTab(3)}>Файлы</Button>
                </>
              }
            </div>
          </div>
        </div>
        <div className={styles.modalLocal} >
          <div className={styles.tabWrapper} >
            {activeTab == 1 &&
              // values &&
              <>
                <div className={styles.inputsRow}>
                  <Input
                    label='Название'
                    name='assocname'
                    value={values?.assocname || values?.name}
                    error={error('assocname')}
                    onChange={handleChange}
                    style={{ width: '600px' }}
                  />
                </div>
                <div className={styles.inputsRow}>
                  <CustomSelect
                    title="Уровень"
                    valuesName="malid"
                    value={levels && levels.find(el => el.levelname === values?.levelname)?.malid}
                    options={levels && arrayForSelect(levels, 'levelname', 'malid')}
                    setFieldValue={setFieldValue}
                  />
                </div>
              </>
            }
            {activeTab === 2 &&

              <div className={styles.inputsRow}>
                <Table className={styles.tables}>
                  <thead>
                    <tr>
                      <th>ФИО</th>
                      <th>Отчислить</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* {tableList && tableList.map(renderLi)} */}
                    {listMids && listMids.map(el =>
                      <tr>
                        <td>{el.fio}</td>
                        <td><i className={styles.trash} onClick={() => setConfirmation({ id: el.mid, name: el.fio })}><BiTrash /></i></td>
                      </tr>
                    )}
                  </tbody>
                </Table>
                <div className={styles.inputsRow}>
                  <Button
                    style={{ padding: '.5rem 1.5rem', margin: '12px' }}
                    onClick={() => openEnroll()}
                  >
                    <IoIosAdd size={30} />
                    Зачислить
                  </Button>
                </div>
              </div>
            }
            {activeTab === 3 &&
              <div className={styles.buttons_wrap}>
                <div className={styles.buttons}>
                  <>
                    <Button onClick={handlePick}>Выбрать файл</Button>
                    <input
                      className={styles.hidden}
                      type='file'
                      ref={filePicker}
                      onChange={(e) => handleChangeFile(e)}
                    />
                    {values.file_list.length > 0 && values.file_list.map(el =>
                      <div style={{ marginBottom: '10px' }}>
                        <tr key={el.file_size}>
                          <td> <Button onClick={() => handleTakeFile(el.file_name)} style={{ marginRight: '10px' }}>Скачать файл</Button></td>
                          <td>{el.file_name}</td>
                          <td><i className={styles.trash} onClick={deleteClickHandler({ id: el.file_size, name: el.file_name })}><BiTrash /></i></td>
                        </tr>
                      </div>
                    )}
                  </>
                </div>
              </div>
            }
          </div>
        </div>

        <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
      </>
      {
        openEnrollModal &&
        <EnrollModal
          closeModal={closeEnroll}
          data={openEnrollModal}
          height={'430px'}
          handleChangeStudents={handleChangeStudents}
          selectedStudents={selectedStudents}
          listMids={listMids ? listMids : []}
          methodAssoc={methodAssoc}
        />
      }
    </Modal >

  )
}
